var map = {
	"./de/title.png": "tcHI",
	"./en/title.png": "g8TB",
	"./es/title.png": "1rWR",
	"./fr/title.png": "ocjv",
	"./ja/title.png": "BKbr",
	"./ko/title.png": "x6j6",
	"./pt/title.png": "x4q1",
	"./ru/title.png": "lMvd",
	"./tc/title.png": "vAmN",
	"./th/title.png": "jeiH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2j4";